import React from 'react';
import { IProps } from './type';

const GoogleIcon = ({ cName, width, height, fillColor, strokeColor, viewBox, onClick }: IProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23.4873 12.6026C23.4873 11.6649 23.409 10.9806 23.2397 10.271H12.2285V14.5033H18.6918C18.5616 15.5551 17.8579 17.1391 16.2942 18.2034L16.2722 18.3451L19.7538 20.9679L19.995 20.9913C22.2102 19.0018 23.4873 16.0746 23.4873 12.6026Z" fill="#4285F4" />
      <path d="M12.2269 23.753C15.3934 23.753 18.0517 22.7392 19.9934 20.9906L16.2926 18.2027C15.3023 18.8743 13.9731 19.3432 12.2269 19.3432C9.12559 19.3432 6.49335 17.3538 5.55503 14.604L5.41749 14.6154L1.79734 17.3398L1.75 17.4678C3.67857 21.1932 7.64 23.753 12.2269 23.753Z" fill="#34A853" />
      <path d="M5.55597 14.6043C5.30839 13.8947 5.1651 13.1344 5.1651 12.3487C5.1651 11.563 5.30839 10.8028 5.54295 10.0932L5.53639 9.94203L1.87087 7.17383L1.75095 7.2293C0.95609 8.77527 0.5 10.5113 0.5 12.3487C0.5 14.1861 0.95609 15.9221 1.75095 17.4681L5.55597 14.6043Z" fill="#FBBC05" />
      <path d="M12.227 5.35408C14.4292 5.35408 15.9147 6.27911 16.7617 7.05214L20.0716 3.90953C18.0388 2.07213 15.3934 0.944336 12.227 0.944336C7.64 0.944336 3.67857 3.50401 1.75 7.22948L5.54201 10.0933C6.49335 7.34357 9.12559 5.35408 12.227 5.35408Z" fill="#EB4335" />
    </svg>
  )
};

export default GoogleIcon;
